/** @import FileItem from '@/classes/files/FileItem' */

/**
 * Acción para la representación di ficheros
 */
export default class Action {
  /** @type {function(FileItem): void} */ handler
  /** @type {function(FileItem): boolean} */ show
  /** @type {String} */ name
}
